export default "__VITE_ASSET__896b402c__"